import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "./services/auth.service";
import { Type } from '@angular/core';
import moment from 'moment';

let done = false;
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    public auth: AuthService,
    protected router: Router, 
    private toastr:ToastrService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.auth.getToken();
    if (token) {
      request = request.clone({
        setHeaders: {
          // 'Content-Type': 'application/json; charset=utf-8',
          // "Content-Type": "multipart/form-data",
          // Accept: 'application/json',
          Authorization: `Bearer ${token}`,
          local_timezone: moment.tz.guess(),
          timezone_offset: moment().format("Z"),
          component_name: this.getCurrentComponentName()
        },
      });
    }
    return next.handle(request)
    .pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
            const response:any = event;
            if(response && response.body) {
              const {status} = response.body;
              if (!done && parseInt(status) === 401 ) {
                  this.toastr.clear();
                  this.toastr.error("Your session expired or account has logged in on another device");
                  // localStorage.clear();
                  this.auth.cleanupLogout();
                // this.router.navigate(['/login']); 
                done = true;
                const code = localStorage.getItem("companyCode");
                if (code) {
                  window.location.href = `/login/${code}`;
                } else {
                  window.location.href = '/login';
                }
              }
            }
          }
        }), 
        catchError(err => {
          if (!done && err.status == 400) {

            this.toastr.clear();
            this.toastr.error("Your session expired please login again");
            // localStorage.clear();
            this.auth.cleanupLogout();
            // this.router.navigate(['/login']); 
            done = true;
            const code = localStorage.getItem("companyCode");
            if(code) {
              window.location.href = `/login/${code}`;
            }else {
              window.location.href = '/login';
            }
          }

          return of('error', err)
        })
      );
  }
  getCurrentComponentName(): string {
    let route = this.router.routerState.root;
  
    while (route?.firstChild) {
      route = route.firstChild;
    }
  
    const component = route?.snapshot?.component;
  
    return (component && (component as Type<any>).name) || 'Unknown Component';
  }
  
}